import { render } from "./criticView.vue?vue&type=template&id=53d965b5"
import script from "./criticView.vue?vue&type=script&lang=js"
export * from "./criticView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__